import { api } from "@/lib/axios";

export async function downloadReport(
  path: string,
  params: Record<string, string | number | undefined>,
  filename: string,
): Promise<void> {
  const clean: Record<string, string | number> = {};
  for (const [k, v] of Object.entries(params)) {
    if (v !== undefined && v !== "") {
      clean[k] = v;
    }
  }
  const { data } = await api.get(path, {
    params: clean,
    responseType: "blob",
  });
  const url = URL.createObjectURL(data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
